import React from 'react';
import { string, func } from 'prop-types';
import styles from './styles/styles.module.scss';
import ExitCircle from './ExitCircle';

const SuggestionCardBase = ({ title, subtext, imgSrc, onClearClick, button }) => {
  return (
    <div className={styles.container}>
      {onClearClick && <ExitCircle onClick={onClearClick} className={styles.exitCircle} />}
      <img className={styles.img} src={imgSrc} alt={title} />
      <div className={styles.title}>{title}</div>
      <div className={styles.subtext}>{subtext}</div>
      {button}
    </div>
  );
};

SuggestionCardBase.propTypes = {
  title: string.isRequired,
  subtext: string.isRequired,
  imgSrc: string.isRequired,
  onClearClick: func
};

SuggestionCardBase.defaultProps = {
  onClearClick: null
};

export default SuggestionCardBase;
